import type { ColumnOrColumnGroup, PredictionMarketColumnParams } from '@talos/kyoko';
import {
  getPredictionMarketsPriceColumn,
  getPredictionMarketsQuantityColumn,
  type PredictionMarketsPriceGridColumnParams,
} from './predictionMarketPriceColumn';

const PREDICTION_MARKET_PRICE_GRID_COLUMN_PARAMS: PredictionMarketColumnParams = {
  symbolField: 'security.Symbol',
};

export type { PredictionMarketsPriceGridColumnParams };

export function getPredictionMarketsPriceGridColumns(
  params: PredictionMarketsPriceGridColumnParams
): ColumnOrColumnGroup[] {
  return [
    {
      type: 'predictionCategory',
      id: 'Category',
      title: 'Category',
      initialWidth: 120,
      sortable: true,
      params: PREDICTION_MARKET_PRICE_GRID_COLUMN_PARAMS,
    },
    {
      type: 'predictionSeries',
      id: 'Series',
      title: 'Series',
      initialWidth: 160,
      sortable: true,
      params: PREDICTION_MARKET_PRICE_GRID_COLUMN_PARAMS,
    },
    {
      type: 'predictionExpiry',
      id: 'Expiry',
      field: 'expiration',
      title: 'Expiry',
      initialHide: true,
      sortable: true,
    },
    getPredictionMarketsQuantityColumn(),
    getPredictionMarketsPriceColumn(params),
  ];
}
